module.exports = __webpack_public_path__ + "static/media/undo_filled_small.21abb475.svg";